export const DATEPICKER_FORMAT = 'DD-MM-YYYY';
export const DATE_DETAILS_FORMAT = 'DD-MM-YYYY HH:mm';
export const FULL_DATE_FORMAT = 'DD-MM-YYYY HH:mm:ss';
export const TIME_DETAILS_FORMAT = 'HH:mm';
export const ERROR_SAVING_PERIOD_DAYS = 30;
export const ERROR_SAVING_LAST_COUNT = 100;

export const COST_SHORT_DATE_FORMAT = 'DD-MM';
export const COST_HOUR_FORMAT = 'HH:mm';
export const COST_CHART_TYPE = {
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month'
};

export const REFRESH_TIMEOUT_2_SEC = 2000;
export const REFRESH_TIMEOUT_10_SEC = 10000;
export const REFRESH_TIMEOUT_60_SEC = 60000;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/data.constant.js